import React from 'react'
import { Toggle as RToggle } from 'rsuite';
const Toggle = ({ component, onChange }: any) => {
    let value;
    if(component.valueID) {
        value = component[component.valueID]
    } else {
        value = component.val
    }
    return  <RToggle checked={value} onChange={onChange} />
}

export default Toggle
